module.exports = __webpack_public_path__ + "static/IEP-e7e5bcd06f02b999712c81dd01126668.pdf";